import { useStyletron } from "baseui";
import { HeadingXLarge, ParagraphMedium } from "baseui/typography";
import React from "react";
import { DocsInterface, type DocsInterfaceProps } from "../../../../../src/chrome/DocsInterface";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../../src/components/SplashPage";
import { Callout, DocLink, InlineCode } from "../../../../../src/markdown-components";

const WorkingWithAgentsLandingPage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Working with agents</HeadingXLarge>
        <ParagraphMedium
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale400,
          }}
        >
          Gadget is designed to work alongside AI coding tools like Claude Code and Codex. Use the Gadget CLI and local development tools to
          connect AI agents to live Gadget environments, and run multiple agents in parallel using separate local workspaces.
        </ParagraphMedium>
        <Callout>
          <ParagraphMedium
            $style={{
              paddingBottom: $theme.sizing.scale600,
            }}
          >
            Start with the{" "}
            <DocLink href="/reference/ggt">
              <InlineCode>ggt</InlineCode> CLI reference
            </DocLink>{" "}
            for the commands used throughout these guides. Run <InlineCode>ggt agent-plugin install</InlineCode> in your project to add{" "}
            <InlineCode>AGENTS.md</InlineCode> and Gadget skills to your project.
          </ParagraphMedium>
        </Callout>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Prompt guide"
            color={colors.white}
            body="Learn how to set up AI coding tools for Gadget development, provide context, and install agent skills."
            href="/guides/development-tools/working-with-agents/prompt-guide"
            copy="Read the guide →"
          />
          <SplashCard
            title="Working in parallel"
            color={colors.white}
            body="Run multiple AI agents simultaneously using separate local workspaces and Gadget environments."
            href="/guides/development-tools/working-with-agents/working-in-parallel"
            copy="Read the guide →"
          />
        </SplashCardGrid>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default WorkingWithAgentsLandingPage;
